$(document).ready(function () {
  // ------------------- TB_collection_CMS Start -------------------
  var tb_daimond_cms = $("#TB-collection-cms .owl-carousel").owlCarousel({
    items: 9, //1 items above 1000px browser width
    nav: false,
    dots: true,
    loop: false,
    margin: 15,
    autoplayHoverPause: true,
    autoplay: true,
    responsive: {
      0: {
        items: 1,
      },
      361: {
        items: 2,
      },
      576: {
        items: 3,
      },
      992: {
        items: 4,
      },
      1200: {
        items: 5,
      },
      1600: {
        items: 6,
      },
    },
  });
  // ------------------- TB_collection_CMS End -------------------

  // ------------------- TB_category_featured Start -------------------
  var TB_category_featured = $(document).ready(function () {
            $("#TB-category-featured .owl-carousel").owlCarousel({
                items: 6,
                loop: false,
                dots: false,
                margin: 0,
                autoplay: true,
                autoplayTimeout: 4000,
                autoplayHoverPause: true,
                responsive: {
                    0: {
                        items: 1,
                    },
                    576: {
                        items: 2,
                    },
                    992: {
                        items: 3,
                    },
                    1200: {
                        items: 4,
                    },
                    1500: {
                        items: 5,
                    },
                    1700: {
                        items: 6,
                    }
                },
            });
        });
  // ------------------- TB_category_featured End -------------------

  // ------------------- TB-video-cms Start -------------------
  var tb_video_cms = $("#TB-video-cms .owl-carousel").owlCarousel({
    items: 5,
    nav: false,
    dots: true,
    loop: false,
    margin: 30,
    responsive: {
      0: {
        items: 1,
        margin: 15,
      },
      481: {
        items: 2,
        margin: 15,
      },
      768: {
        items: 3,
        margin: 15,
      },
      1200: {
        items: 4,
      },
      1500: {
        items: 5,
      },
    },
  });
  // ------------------- TB-video-cms End -------------------
});
